import { DomainUpsertLoadingList } from "@/components/domain";
import { useSyncLoading } from "@/context/sheet";
import { useGetPayment, useUpdatePayment } from "@/hooks/payments";
import { CreatePayment, Payment } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-components/form";

export const Route = createFileRoute("/(payments)/payments/$id/_sheet/$pid")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id, pid } = Route.useParams();

  const { isLoading, data: model } = useGetPayment(pid);
  useSyncLoading(isLoading);

  if (isLoading || !model) return <DomainUpsertLoadingList />;
  return <Edit model={model} reservationId={id} />;
}

function Edit({
  model,
  reservationId,
}: {
  model: Payment;
  reservationId: string;
}) {
  const navigate = useNavigate();
  const { mutateAsync } = useUpdatePayment(reservationId, {
    onSuccess: () => {
      navigate({
        to: "/payments/$id",
        params: { id: reservationId },
      });
    },
  });

  const update = async (payment: CreatePayment) => {
    await mutateAsync({ id: model.id, ...payment });
  };
  return (
    <Form
      isDeposit={model.isDeposit}
      model={model}
      onUpsert={update}
      reservationId={reservationId}
    />
  );
}
